<ng-container ngForm>
  @if (isFileReaderApiAvailable) {
    <tg-file-uploader
      (ngModelChange)="onFilesSelected($event)"
      [accept]="acceptedMimeTypesList"
      label="Add photo"
      name="listing-progress-add-photo"
      ngModel
      showLabel="false"
      showValidation="false"
      >
      <ng-content></ng-content>
    </tg-file-uploader>
  }
  @if (!isFileReaderApiAvailable) {
    <div>
      <ng-content select="[file-upload-disabled]"> </ng-content>
    </div>
  }
</ng-container>
